"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalHeader = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const background_modal_1 = __importDefault(require("../background-modal"));
const Content = styled_components_1.default.div `
  background-color: ${({ theme }) => theme.white};
  box-shadow: 0px 6px 15px rgba(0, 0, 0, 0.2);
  border-radius: 32px;
  padding: 32px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  width: ${({ size }) => {
    if (size === "small")
        return "min(calc(100% - 96px), 550px)";
    if (size === "medium")
        return "min(calc(100% - 96px), 1084px)";
    return "min(calc(100% - 96px), 1546px)";
}};

  max-height: ${({ size }) => {
    if (size === "small")
        return "448px";
    if (size === "medium")
        return "min(calc(100vh - 96px), 788px)";
    return "min(calc(100vh - 96px), 1053px)";
}};
`;
const ContentWrapper = styled_components_1.default.div `
  overflow-y: auto;
`;
const HeaderWrapper = styled_components_1.default.div `
  display: grid;
  grid-template-columns: ${({ isStartAction, isEndAction }) => `${isStartAction ? "auto" : ""} 1fr ${isEndAction ? "auto" : ""}`};
  gap: 16px;
  align-items: start;
  padding: 16px 0px;
`;
const Heading = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
`;
const Title = styled_components_1.default.div `
  font-weight: 700;
  font-size: 32px;
  line-height: 35px;
`;
const Subtitle = styled_components_1.default.div `
  font-weight: 500;
  font-size: 20px;
  line-height: 19px;
  margin-top: 8px;
`;
const ModalHeader = ({ startAction, endAction, title, subtitle }) => {
    return (react_1.default.createElement(HeaderWrapper, { isStartAction: !!startAction, isEndAction: !!endAction },
        startAction && startAction,
        title || subtitle ? (react_1.default.createElement(Heading, null,
            title && react_1.default.createElement(Title, null, title),
            subtitle && react_1.default.createElement(Subtitle, null, subtitle))) : (react_1.default.createElement("div", null) // Empty div to keep the grid layout
        ),
        endAction && endAction));
};
exports.ModalHeader = ModalHeader;
const ModalNew = ({ children, size = "large", header, footer, onClose }) => {
    return (react_1.default.createElement(background_modal_1.default, { handleClose: onClose },
        react_1.default.createElement(Content, { size: size, onClick: e => e.stopPropagation() },
            header && header,
            react_1.default.createElement(ContentWrapper, null, children),
            footer && footer)));
};
exports.default = ModalNew;
